export default "__VITE_ASSET__B23UIxP0__"